import { useEffect, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import OktaAuth from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import { AppRoutes, LoginPage, LogoutPage, SecureRoute } from 'components';
import { oktaConfig } from 'config/oktaConfig';
import { useAuthConfig } from 'state';
import { TestDebugUserPage } from 'pages';

function Routing() {
	const config = useAuthConfig();
	const oktaAuth = useMemo(() => {
		return new OktaAuth({ ...oktaConfig, ...config });
	}, [config]);

	const restoreOriginalUri = async (oktaAuth: OktaAuth, originalUri: string) => {
		//const appRoot = process.env.PUBLIC_URL ? `/${process.env.PUBLIC_URL}` : ''
		window.location.href = `${window.location.origin}${originalUri ?? ''}`
	}

	// This is to avoid the "Two custom restoreOriginalUri callbacks are detected" message.
	useEffect(() => {
		return () => {
			oktaAuth.options.restoreOriginalUri = undefined
		}
	}, [])

	return (
		<Security
			oktaAuth={oktaAuth}
			onAuthRequired={() => oktaAuth.signInWithRedirect()}
			restoreOriginalUri={restoreOriginalUri}
		>
			<Routes>
				<Route path="implicit/callback" element={<LoginCallback />} />
				<Route path="*" element={<SecureRoute path="*" element={<AppRoutes />}></SecureRoute>} />
				<Route path="logout" element={<LogoutPage />} />
				<Route path="login" element={<LoginPage />} />
				
				<Route path="debug/current-user" element={<TestDebugUserPage />} />
			</Routes>
		</Security>
	);
}

export default Routing;